
export const text = `
[ID: A photo of a mannequin sitting on an old sofa; there is a controller balanced between its hands, its back hunched over, like it is playing a video game. There is an old TV on the table in front of it-- the angle makes it hard to tell what the game is, if any. Its head is nowhere to be seen.]

`